<template>
  <ORingAssistantStepCards :cards="cards" />
</template>

<script setup lang="ts">
import ORingAssistantStepCards from './OringAssistantStepCards.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import radialPng from '~/assets/images/radial.png'
import axialPng from '~/assets/images/axial.png'
import hydraulicPng from '~/assets/images/hydraulic.png'
import pneumaticPng from '~/assets/images/pneumatic.png'
import {useORingCalculatorStore} from '@/store/oring-calculator'
import {storeToRefs} from 'pinia'

const i18n = useI18nExtended()
const store = useORingCalculatorStore()
const {oringAssistantIsRadial, oringAssistantIsHydraulic} = storeToRefs(store)

const cards = [
  {
    title: i18n.tv('Frontend.Title.RingCompression', 'ORingConfiguratorImport'),
    description: i18n.tv('Frontend.Message.RingCompression', 'ORingConfiguratorImport'),
    model: oringAssistantIsRadial,
    options: [
      {value: true, label: i18n.tv('Frontend.Application.Radial', 'ORingConfiguratorImport'), imgUrl: radialPng},
      {value: false, label: i18n.tv('Frontend.Application.Axial', 'ORingConfiguratorImport'), imgUrl: axialPng}
    ],
    popupContent: {title: i18n.tv('Frontend.Title.RingCompression', 'ORingConfiguratorImport'), content: i18n.tv('Frontend.Info.RingCompressionOne', 'ORingConfiguratorImport')}
  },
  {
    title: i18n.tv('Frontend.Title.Medium', 'ORingConfiguratorImport'),
    description: i18n.tv('Frontend.Message.Medium', 'ORingConfiguratorImport'),
    model: oringAssistantIsHydraulic,
    options: [
      {value: true, label: i18n.tv('Frontend.Application.Hydraulic', 'ORingConfiguratorImport'), imgUrl: hydraulicPng},
      {value: false, label: i18n.tv('Frontend.Application.Pneumatic', 'ORingConfiguratorImport'), imgUrl: pneumaticPng}
    ],
    popupContent: {title: i18n.tv('Frontend.popupInfoTitle.Medium', 'ORingConfiguratorImport'), content: i18n.tv('Frontend.Info.MediumOne', 'ORingConfiguratorImport')}
  }
]
</script>
